// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_aq-0";
export var actionModalContentContainer = "_aq-1";
export var createTagButton = "_aq-2";
export var footerContainer = "_aq-7";
export var fullWidthDivider = "_aq-3";
export var hasCreateTagButton = "_aq-4";
export var noCreateTagButton = "_aq-5";
export var tagsContainer = "_aq-6";
export var tagsModalContentContainer = "_aq-8";